module.exports = __webpack_public_path__ + "img/info3_w.56e819cc.svg";